import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import Tooltip from 'LuxKit/Tooltip'
import SolidExclamationCircleIcon from 'LuxKit/Icons/solid/SolidExclamationCircleIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { ATOL_REGIONS } from 'constants/config/region'

function AtolProtectedTooltipContainer() {
  const { currentRegionCode } = useContext(GeoContext)

  if (!ATOL_REGIONS.includes(currentRegionCode)) {
    return null
  }

  return (
    <Tooltip description={<>
      <b>This trip is ATOL protected</b> for your full peace of mind.
    </>}
    >
      <CaptionTextBlock variant="medium" endIcon={<SolidExclamationCircleIcon colour="primary" />}>
        ATOL protected
      </CaptionTextBlock>
    </Tooltip>
  )
}

export default AtolProtectedTooltipContainer
